export default __webpack_public_path__ + "static/media/bg-hero.360f0c49.svg";